import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PlanoCpfEscada {
  codigo: string;
  nome: string;
  gb: number;
  valor: number;
}

/**
 * A escada de planos móveis CPF, do mais barato ao mais caro.
 *
 * É o que o comparativo da portabilidade CPF usa para sugerir o plano pelo GB
 * que o cliente realmente usa. Sai do catálogo do banco, nunca de valor escrito
 * no código: tabela nova da Claro muda o catálogo e o comparativo acompanha.
 */
export function usePlanosCpfEscada() {
  return useQuery({
    queryKey: ['planos-cpf-escada'],
    staleTime: 30 * 60 * 1000,
    queryFn: async (): Promise<PlanoCpfEscada[]> => {
      const { data, error } = await supabase
        .from('planos_proposta_catalogo')
        .select('codigo, nome, gb, valor')
        .eq('tipo_pessoa', 'PF')
        .eq('categoria', 'pn_novo')
        .eq('ativo', true);
      if (error) throw error;
      return ((data || []) as PlanoCpfEscada[])
        .map((p) => ({ ...p, gb: Number(p.gb) || 0, valor: Number(p.valor) || 0 }))
        .filter((p) => p.gb > 0 && p.valor > 0)
        .sort((a, b) => a.valor - b.valor);
    },
  });
}
